"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAIRING_EVENTS = exports.PAIRING_STATUS = exports.PAIRING_SIGNAL_METHOD_URI = exports.PAIRING_DEFAULT_TTL = exports.PAIRING_CONTEXT = exports.PAIRING_JSONRPC = void 0;
const time_1 = require("./time");
exports.PAIRING_JSONRPC = {
    propose: "wc_pairingPropose",
    approve: "wc_pairingApprove",
    reject: "wc_pairingReject",
    update: "wc_pairingUpdate",
    upgrade: "wc_pairingUpgrade",
    delete: "wc_pairingDelete",
    payload: "wc_pairingPayload",
    ping: "wc_pairingPing",
    notification: "wc_pairingNotification",
};
exports.PAIRING_CONTEXT = "pairing";
exports.PAIRING_DEFAULT_TTL = time_1.THIRTY_DAYS;
exports.PAIRING_SIGNAL_METHOD_URI = "uri";
exports.PAIRING_STATUS = {
    proposed: "proposed",
    responded: "responded",
    pending: "pending",
    settled: "settled",
};
exports.PAIRING_EVENTS = {
    proposed: "pairing_proposed",
    responded: "pairing_responded",
    settled: "pairing_settled",
    updated: "pairing_updated",
    deleted: "pairing_deleted",
    request: "pairing_request",
    response: "pairing_response",
    enabled: "pairing_enabled",
    disabled: "pairing_disabled",
    sync: "pairing_sync",
    notification: "pairing_notification",
};
//# sourceMappingURL=pairing.js.map